// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"bb687f2efbd95d28d0e0","777":"41b662add688a1d272bd"}[chunkId] + ".js";
};